import React, { useMemo, useState } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, ModalComponent,  SelectFieldIcon, TextFieldIcon, TextField, PhoneFieldIcon } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'

const steps = [
  "Pending", "Actioned"
]


export default function AllUsers( ) {
    const ActionField = ( record ) => {
        return (
            <div onClick={async () => {
                //await localStorage.setItem( "link", "display" )
                await localStorage.setItem( "assigned_user", record.id )
                setCreatetask(true)
                //return window.location.reload()
            } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
                {`Action`}
            </div>
        )
    }

    const ApplicantFieldAction = ( record ) => {
        return (
          <div onClick={async () => {
                await localStorage.setItem( "assigned_applicant", record.id )
                setViewApplicant(true)
                getApplicantDetails(record.email)
            }} className="cursor-pointer w-auto md:w-10 lg:w-14 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View`}
          </div>
        )
    }

    const ApplicantDeleteAction = ( record ) => {
        return (
          <div onClick={async () => {
                let applicant_id = record.id
                console.log("You want to delete applicant "+applicant_id)
                if (window.confirm("Are you sure you want to delete this user ?") == true) {
                    try {
                        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/delete_user`,{
                            user_id: applicant_id
                        } ) 
                        if( response.data.message ) {
                            alert(response.data.message)
                            return window.location.reload()
                        }
                    } catch (error) {
                        alert("There was an error deleting user")
                        console.log("There was an error deleting user")
                        console.log(error)
                    }
                }
            }} className="cursor-pointer w-auto md:w-10 lg:w-14 py-1 rounded bg-[#b14141] text-xs text-white flex items-center justify-center">
            {`Delete`}
          </div>
        )
    }

    const UserColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Name",
        accessor: "applicant"
        },
        {
        Header: "User Role",
        accessor: "user_role"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Created On",
        accessor: "date"
        }
        ,
        {
        Header: "Action",
        accessor: ActionField
        }
    ] )

    const ApplicantColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Name",
        accessor: "name"
        },
        {
        Header: "Domain",
        accessor: "domain"
        },
        {
        Header: "Phone",
        accessor: "phone_number"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Created On",
        accessor: "date"
        }
        ,
        {
        Header: "Action",
        accessor: ApplicantFieldAction
        },
        {
        Header: "Delete",
        accessor: ApplicantDeleteAction
        }
    ] )
    
    const [ records, setRecords ] = useState( [] )
    const [ applicants, setApplicants ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    const [ createtask, setCreatetask] = useState( false );
    const [ userRoleTransfer, setUserRoleTransfer] = useState( false );
    const [ userEdit, setUserEdit] = useState( false );
    const [ viewApplicant, setViewApplicant] = useState( false );
    const [ applicantRecord, setApplicantRecord ] = useState( {} )

    React.useEffect( () => {
        if( loading ) {
            fetchUsers()
        }
    },[ loading ])

    const fetchUsers = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcouser` ) 
            if( response.data ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.applicant,
                        user_role: result.user_role,
                        phone_number: result.phone_number,
                        email_address: result.email_address,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.user_role?.toUpperCase() !== "APPLICANT"
                } )

                const applicant_users = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        name: result.first_name,
                        domain: result.domain,
                        user_role: result.user_role,
                        phone_number: result.phone_number,
                        email_address: result.email_address,
                        email: result.email,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.user_role?.toUpperCase() === "APPLICANT"
                } )

                //update the state
                setRecords( results )
                setApplicants( applicant_users )
                setLoading( false )
            }
        } catch (error) {
            alert( "Server error occurred." )
            setLoading( false )
        }
    }

    const getApplicantDetails = async(applicant_email) => {
        const single_application = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication_email/`+ applicant_email) 
        if( single_application.data ) {

            //update the state
            setApplicantRecord( single_application.data.record )
            console.log("work hard")
            console.log(applicantRecord.trading_name)
            setLoading( false )
        }
    }

    const handleUserRoleTransfer = async ( values ) => {
        //await setCircularLoading( true )

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/temporary_role_transfer`, {
                actioned_by: localStorage.getItem( "username" ),
                assigned_user: localStorage.getItem( "assigned_user" ),
                assigned_role: values.assigned_role,
                end_date: values.end_date
            } )

            if( response.data ) {
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    const handleEditUser = async ( values ) => {
        //await setCircularLoading( true )

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/update_user`, {
                actioned_by: localStorage.getItem( "username" ),
                assigned_user: localStorage.getItem( "assigned_user" ),
                assigned_role: values.assigned_role,
                end_date: values.end_date
            } )

            if( response.data ) {
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    if( localStorage.getItem( "link" ) === "all_users" ){

        return (        
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Registered Users`}
                        </div>
                        <div className="flex flex-col justify-center w-full bg-white">
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="Application Details"
                            columns={UserColumns}
                            data={records}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
                <ModalComponent title={`Action`} open={createtask}>
                    <div className="flex flex-col items-center justify-center">
                        <button onClick={async () => {
                            //await localStorage.setItem( "application_action", "VERIFIER" )
                            //return window.location.reload()
                            setUserRoleTransfer(true)
                            setCreatetask(false)
                            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#369fc8] text-xs text-white flex items-center justify-center">
                            Transfer User Role Temporarily
                        </button>

                        <button onClick={async () => {
                            //await localStorage.setItem( "application_action", "VERIFIER" )
                            //return window.location.reload()
                            setUserEdit(true)
                            setCreatetask(false)
                            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#866ec9] text-xs text-white flex items-center justify-center">
                            Edit User 
                        </button>

                        <button onClick={async () => {
                            setCreatetask(false)
                            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#54554d] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>

                <ModalComponent title={`Action`} open={userRoleTransfer}>
                    <div className="flex flex-col items-center justify-center">
                        <Formik initialValues={{
                            action: "",
                            actioned_by: localStorage.getItem( "username" ),
                            comments: ""
                            }} onSubmit={handleUserRoleTransfer}>
                            { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                return (
                                    <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>
                            
                                        <SelectFieldIcon 
                                            name="assigned_role"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.assigned_role}
                                            label="Assign Role To User"
                                            required={true}
                                            disabled={false}
                                            options={[
                                                { id: 1, value: "VERIFIER", label: "Verifier" },
                                                { id: 2, value: "AUDITOR", label: "Auditor" },
                                                { id: 3, value: "QA1", label: "Quality Assurance 1" },
                                                { id: 4, value: "QA2", label: "Quality Assurance 2" },
                                                { id: 5, value: "QA3", label: "Quality Assurance 3" },
                                                { id: 6, value: "APPROVER", label: "Approver" },
                                                { id: 7, value: "SECURITY", label: "Security" },
                                            ]}
                                            question="Assign Role To User" />

                                        <TextFieldIcon 
                                            type="date"
                                            name="end_date"
                                            value={values.end_date}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="End Date"
                                            disabled={false}
                                            question={`End Date`}
                                            required={true} 
                                        />

                                        <button type="submit" className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#278556] text-xs text-white flex items-center justify-center">
                                            Submit
                                        </button>
                                    </form>
                            )
                        }  }
                        </Formik>

                        <button onClick={async () => {
                            setUserRoleTransfer(false)
                            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#54554d] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>

                <ModalComponent title={`Edit User`} open={userEdit}>
                    <div className="flex flex-col items-center justify-center">
                        <Formik initialValues={{
                            action: "",
                            actioned_by: localStorage.getItem( "username" ),
                            comments: ""
                            }} onSubmit={handleEditUser}>
                            { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                return (
                                    <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                        <TextFieldIcon 
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Username"
                                            disabled={false}
                                            question={`Username`}
                                            required={true} 
                                        />

                                        <TextFieldIcon 
                                            type="email"
                                            name="user_email"
                                            value={values.user_email}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            label="Email"
                                            disabled={false}
                                            question={`Email`}
                                            required={true} 
                                        />

                                        <PhoneFieldIcon 
                                            name="user_phone_number"
                                            handleChange={evt => {
                                                handleChange(evt)
                                            }}
                                            handleBlur={handleBlur}
                                            callback={ ( phone ) => {
                                                //setPhone( phone )
                                            } }
                                            question="Phone Number"
                                        />

                                        <SelectFieldIcon 
                                            name="assigned_role"
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.assigned_role}
                                            label="Assign Role To User"
                                            required={true}
                                            disabled={false}
                                            options={[
                                                { id: 1, value: "VERIFIER", label: "Verifier" },
                                                { id: 2, value: "AUDITOR", label: "Auditor" },
                                                { id: 3, value: "QA1", label: "Quality Assurance 1" },
                                                { id: 4, value: "QA2", label: "Quality Assurance 2" },
                                                { id: 5, value: "QA3", label: "Quality Assurance 3" },
                                                { id: 6, value: "APPROVER", label: "Approver" },
                                                { id: 7, value: "SECURITY", label: "Security" },
                                            ]}
                                            question="Assign Role To User" 
                                        />
                                </form>
                                )
                            }  }
                        </Formik>

                        <button onClick={async () => {
                            setUserEdit(false)
                            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#54554d] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>
            </Wrapper>

        )
    }

    if( localStorage.getItem( "link" ) === "all_applicants" ){

        return (        
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Registered Applicants`}
                        </div>
                        <div className="flex flex-col justify-center w-full bg-white">
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="Application Details"
                            columns={ApplicantColumns}
                            data={applicants}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>

                <ModalComponent title={`Action`} open={viewApplicant}>
                    <div className="flex flex-col items-center justify-center">
                        <table>
                            <tr>
                                <td><strong>Trading Name:</strong></td>
                                <td>{applicantRecord.trading_name}</td>
                            </tr>

                            <tr>
                                <td><strong>Annual Turnover:</strong></td>
                                <td>{applicantRecord.annual_turnover}</td>
                            </tr>

                            <tr>
                                <td><strong>TIN:</strong></td>
                                <td>{applicantRecord.tin}</td>
                            </tr>

                            <tr>
                                <td><strong>ISIC Code:</strong></td>
                                <td>{applicantRecord.iso_number}</td>
                            </tr>
                        </table>
                    </div>
                    <button onClick={async () => {
                        setViewApplicant(false)
                        } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#54554d] text-xs text-white flex items-center justify-center">
                        Close
                    </button>
                </ModalComponent>
            </Wrapper>
        )
    }
}